import { render } from "./PedidoImportadoDetalle.vue?vue&type=template&id=de0d1de8"
import script from "./PedidoImportadoDetalle.vue?vue&type=script&lang=js"
export * from "./PedidoImportadoDetalle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__